module.exports = __webpack_public_path__ + "img/exit.e9e5fc16.svg";